import { connect } from 'react-redux';
import SmtpView from './SmtpView.jsx';
import { fetchSmtpIntegration } from 'src/legacy/redux/actions/integrations/smtpIntegration.jsx';
import { fetchIntegrations } from "src/legacy/redux/actions/integrations.jsx";
import { getIntegrationForType } from 'src/legacy/redux/actions/integrations.jsx';
import withUseHooks from 'src/legacy/components/withUseHooks.jsx';

const mapStateToProps = (state, ownProps) => {
  let integration = getIntegrationForType(state, 'smtp');
  return {
    integration: integration,
    integrations: state.legacyRootReducer.settings.integrations,
    deactivating: state.legacyRootReducer.settings.integrations.activated.deactivating.loading,
    }
}

const mapDispatchToProps = (dispatch) => {
  return {
    fetchSmtpIntegration: () =>{
      return dispatch(fetchSmtpIntegration());
    },

    
    fetchIntegrations: () => {
      return dispatch(fetchIntegrations());
    }
  }
}

const SmtpPage = connect (
    mapStateToProps,
    mapDispatchToProps
)(SmtpView);

export default withUseHooks(SmtpPage);
